import SearchIcon from '@mui/icons-material/Search';
import { FormControl } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import { SearchInputStyles } from './styles';
import { SearchInputProps } from './types';

export function SearchInput({ label, placeholder, onChange, name, value, onKeyDown, InputProps }: SearchInputProps) {
  return (
    <FormControl fullWidth>
      <SearchInputStyles
        inputProps={{ 'data-testid': `search-input-${name}` }}
        fullWidth
        id={label}
        label={label}
        name={name}
        type={'text'}
        autoComplete="off"
        onChange={(e) => onChange(e.target.value, name)}
        value={value}
        placeholder={placeholder || ''}
        onKeyDown={onKeyDown && onKeyDown}
        InputProps={{
          startAdornment: <InputAdornment position="start">{<SearchIcon />}</InputAdornment>,
          ...InputProps,
        }}
      />
    </FormControl>
  );
}
